import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import CustomerButton from "../../customer-button/CustomerButton";
const RateYourExperienceFooter = ({
  onClick,
  classes
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.experienceContainer
  }, /*#__PURE__*/React.createElement(CustomerButton, {
    style: {
      height: 44
    },
    color: "primary",
    onClick: onClick
  }, "Rate your experience"));
};
const styles = () => ({
  experienceContainer: {
    display: "flex",
    flex: "1",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "2px solid rgba(0, 0, 0, 0.06)"
  },
  rateExperienceBtn: {
    height: 44
  }
});
export default withStyles(styles)(RateYourExperienceFooter);
RateYourExperienceFooter.propTypes = {
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};